export default {
    apiKey: "AIzaSyABVQ6v5I6V-fUJ1dC4_O3Gi0p_fujWBLc",
    authDomain: "tawi-website.firebaseapp.com",
    projectId: "tawi-website",
    storageBucket: "tawi-website.appspot.com",
    messagingSenderId: "589264063960",
    appId: "1:589264063960:web:32aaa23839c917c16cb6ad"
};